module.exports = __webpack_public_path__ + "img/Infografis_ID_08.43da5dd3.jpg";